import React from 'react';
import Spinner from '@99designs/react-components/components/Spinner';
import SpinnerContainer from 'launch/components/SpinnerContainer';

export default function loadRoute(componentLoaded, props = {}) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                component: null
            };
        }

        componentDidMount() {
            componentLoaded((component) => {
                this.setState({
                    component: component.default
                });
            });
        }

        render() {
            const { component } = this.state;
            if (component) {
                return React.createElement(component, props);
            } else {
                return (
                    <SpinnerContainer>
                        <Spinner variations={['large', 'inline']} />
                    </SpinnerContainer>
                )
            }
        }
    };
}



// WEBPACK FOOTER //
// ./js/launch/components/loadRoute.jsx